export default __webpack_public_path__ + "static/media/miMatic.1ccf3be7.png";